<template>
    <div class="listCommonClass">
        <div class="listSearchBox">
            <el-input v-model="modelName" placeholder="模型名称"></el-input>
            <el-select v-model="typeFirstUuid" placeholder="一级分类" @change="changeItemList" >
                <el-option v-for="(item,index) in groupList" :key="index" :label="item.label" :value="item.value" >
                </el-option>
            </el-select>
            <el-select v-model="typeSecondUuid" placeholder="二级分类">
                <el-option v-for="(item,index) in itemList" :key="index" :label="item.label" :value="item.value" >
                </el-option>
            </el-select>
            <el-select v-model="publishStatus" placeholder="发布状态">
                <el-option
                    label="草稿"
                    value="DRAFT">
                </el-option>
                <el-option
                    label="审核中"
                    value="REVIEWING">
                </el-option>
                <el-option
                    label="待发布"
                    value="UNRELEASED">
                </el-option>
                <el-option
                    label="已发布"
                    value="RELEASED">
                </el-option>
            </el-select>
            <el-select v-model="attribute" placeholder="支持下载">
                <el-option
                    label="免费"
                    value="FREE">
                </el-option>
                <el-option
                    label="付费"
                    value="PAY">
                </el-option>
                <el-option
                    label="仅预览"
                    value="BROWSE">
                </el-option>
            </el-select>
            <el-button class="searchBtn" @click="getModelList">搜索</el-button>
            <el-button type="text" class="resetBtn" @click="reset">
                <i class="iconfont icon-qingchushujuku"></i>
                <span>清除条件</span>
            </el-button>
        </div>
        <div class="listTableBox">
            <div class="tableTool">
                <div class="toolLeft">
                    <span>已选： <span class="num">{{multipleSelection.length}}</span></span>
                    <!--<el-button type="primary" plain size="small" :disabled="multipleSelection.length<=0" @click="publish('all')">批量发布</el-button>-->
                    <el-button type="primary" plain size="small" :disabled="multipleSelection.length<=0" @click="del('all')">批量删除</el-button>
                    <el-button type="primary" plain size="small" :disabled="multipleSelection.length<=0" @click="handleBatchDownload('all')">批量下载</el-button>
                </div>
                <div class="toolRight">
                    <el-button type="primary" size="small" @click="toDialog('add')">上传模型</el-button>
                </div>
            </div>
            <div class="tableContent">
                <ul class="tableHeader">
                    <li class="select"><el-checkbox v-model="tableHeaderCheck" @change="tableHeaderChange"></el-checkbox></li>
                    <li class="name">模型名称</li>
                    <li class="classify">一级分类</li>
                    <li class="classify">二级分类</li>
                    <li class="status">下载量 <i class="el-icon-bottom"></i></li>
                    <li class="status">访问量 <i class="el-icon-bottom"></i></li>
                    <li class="status">金额</li>
                    <li class="status">状态</li>
                    <li class="status">驳回原因</li>
                    <li class="status">下载/预览</li>
                    <li class="operation">操作</li>
                </ul>
                <ul class="tableBody" v-if="tableListData.length != 0" v-loading="loading">
                    <li class="bodyItem" v-for="(item,index) in tableListData" :key="index">
                        <div class="itemTop">
                            <el-checkbox v-model="item.checked" @change="bodyItemCheckChange"></el-checkbox>
                            <span>上传时间：{{item.modifyDate}}</span>
                        </div>
                        <div class="itemBottom">
                            <div class="name" style="margin-right:22px">
                                <img :src="item.imgUrl" alt="">
                                <span>{{item.modelName}}</span>
                            </div>
                            <div class="classify">{{item.typeFirstName}}</div>
                            <div class="classify">{{item.typeSecondName}}</div>
                            <div class="status">{{item.downNum}}</div>
                            <div class="status">{{item.accessNum}}</div>
                            <div class="status">{{item.price}}</div>
                            <div class="status">{{item.statusCn}}</div>
                            <div class="status">{{item.statusCn == '审核驳回' ? item.reason : ''}}</div>
                            <div class="status">{{item.attributeCn}}</div>
                            <div class="operation">
                                <el-button type="text" size="small" @click="toDialog('edit',item.uuid)">编辑</el-button>
                                <el-button type="text" v-if="item.status == 'UNRELEASED'" size="small" @click="publish(item.uuid)">发布</el-button>
                                <el-button type="text" size="small" @click="handleBatchDownload(item.uuid)">下载</el-button>
                                <el-button type="text" size="small" @click="del(item.uuid)">删除</el-button>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- <div class="orderNomesaage" v-loading="loading" v-else >暂无数据</div> -->
                <div class="orderNomesaage" v-loading="loading" v-else >
                     <img src="../../assets/images/暂无内容.jpg" alt="" style="width:200px">
                </div>
            </div>
            <el-pagination
                v-if="tableListData.length != 0"
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :page-size="pageSize"
                :total="total" class="pagination">
            </el-pagination>
        </div>
        <model-management-dialog  ref="dialogRef" @submit="init"></model-management-dialog>
    </div>
</template>

<script>
    import axios from 'axios'
    import JSZip from 'jszip'
    import FileSaver from 'file-saver'
    import {
        getModelList,
        delModelList,
        releaseModelList,examModelDetail,getDictionaryGroup,getDictionaryItem
    } from "../../utils/interface";
    import {downLoad} from "../../utils/downLoadModel";
    import modelManagementDialog from './modelManagementDialog'

    export default {
        name: "modelManagement",
        data(){
            return{
                modelName: '',
                typeFirstUuid: '',
                typeSecondUuid: '',
                publishStatus: '',
                attribute: '',
                tableHeaderCheck: false,
                loading: true,
                tableListData: [
                ],
                multipleSelection: [],
                groupList:[],
                itemList : [],
                groupMap :{},
                itemMap : {},
                pageNo: 1,
                total: 0,
                pageSize: 5
            }
        },
        components: {
            modelManagementDialog
        },
        created() {
            this.init();
        },
        methods: {
            init(){
                this.$emit('hompageLog','model')
                this.reset();
                this.pageNo=1;
                this.getGroup();
                this.getModelList();
            },
            getGroup(){
                getDictionaryGroup({ parentCode: "MODEL_CATEGORIES" }).then((res) => {
                    res.map((item) => {
                        item.value = item.uuid;
                        item.label = item.name;
                        this.groupMap[item.uuid] = item;
                        getDictionaryItem({groupCode:item.code}).then((itemList)=>{
                            itemList.map((info)=>{
                                info.value = info.uuid;
                                info.label = info.name;
                                this.itemMap[info.uuid] = info;
                            })
                            item.children = itemList;
                        })
                    });
                    this.groupList = res;
                });
            },
            changeItemList(){
                this.typeSecondUuid = "";
                this.itemList = this.groupMap[this.typeFirstUuid].children;
            },
            // 检索重置
            reset(){
                this.modelName = ''
                this.typeFirstUuid = ''
                this.typeSecondUuid = ''
                this.publishStatus = ''
                this.attribute = ''
                this.itemList = []
            },
            // 分页
            handleCurrentChange(val){
                this.pageNo = val
                this.getModelList();
            },
            // 列表选择功能
            tableHeaderChange(val){
                this.tableListData.map(item=>{
                    item.checked = val
                })
                if(val){
                    this.multipleSelection = this.tableListData
                } else {
                    this.multipleSelection = []
                }
            },
            getModelList() {
                // if(this.$store.state.userMessages == null ||!this.$store.state.userMessages.user_uuid  ){
                //     alert("请先登录！");
                //     this.$router.push({name: "login"});
                //     return;
                // }
                this.loading = true
                let params = {
                    isLogin: 2,
                    modelName: this.modelName,
                    typeFirstUuid: this.typeFirstUuid,
                    typeSecondUuid: this.typeSecondUuid,
                    status:this.publishStatus,
                    attribute:this.attribute,
                    current: this.pageNo,
                    pageSize: this.pageSize,
                };
                getModelList(params).then((res) => {
                    this.tableListData = res.list;
                    this.total = res.total;
                    // console.log(this.tableListData);
                    this.loading = false
                });
            },
            bodyItemCheckChange(val){
                this.multipleSelection = this.tableListData.filter(res => res.checked === true)
                if(this.multipleSelection.length === this.tableListData.length){
                    this.tableHeaderCheck = true
                } else {
                    this.tableHeaderCheck = false
                }
            },
            // 编辑/新增
            toDialog(type,id){
                this.$refs.dialogRef.init(type,id)
            },
            // 删除
            del(val){
                let ids = [];
                if(val === 'all'){
                    this.multipleSelection.map((item)=>{
                        ids.push(item.uuid);
                    }).toString()
                } else {
                    ids.push(val)
                }
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delModelList(ids).then((res) => {
                        if(res.success){
                            this.$message({
                                type: 'success',
                                message: '删除成功！'
                            })
                            this.getModelList();
                        }
                    });
                }).catch(() => {})
            },
            // 发布
            publish(val){
                let ids = []
                if(val === 'all'){
                    this.multipleSelection.map((item)=>{
                        if(item.status.toString() === 'UNRELEASED'){
                            ids.push(item.uuid)
                        }
                    })
                    for(let item=0;item<this.multipleSelection.length;item++){
                        // if(this.multipleSelection[item].imgUrl!=null&&this.multipleSelection[item].modelName!=null&&
                        // this.multipleSelection[item].typeFirstName!=null&&this.multipleSelection[item].urlList!=null&&
                        // this.multipleSelection[item].modelDes!=null&&this.multipleSelection[item].remark!=null){
                        //     this.$confirm('确定要发布吗?', '提示', {
                        //             confirmButtonText: '确定',
                        //             cancelButtonText: '取消',
                        //             type: 'warning'
                        //         }).then(() => {
                        //             releaseModelList(ids).then((res) => {
                        //                 console.log(res);
                        //                 if(res.success){
                        //                     this.$message({
                        //                         type: 'success',
                        //                         message: '发布成功！'
                        //                     })
                        //                     this.getModelList();
                        //                 }
                        //             });
                        //         }).catch(() => {})
                        // }else{
                        //     this.$alert("请上传模型图片", "提示", {
                        //         confirmButtonText: "确定",
                        //         });
                        // }
                             if(this.multipleSelection[item].imgUrl==null){
                             this.$alert("请完善显示的模型全部内容，才可进行发布", "提示", {
                                confirmButtonText: "确定",
                                });
                                return;
                        }else if(this.multipleSelection[item].modelName==null){
                             this.$alert("请完善显示的模型全部内容，才可进行发布", "提示", {
                                confirmButtonText: "确定",
                                });
                                return;
                        }else if(this.multipleSelection[item].typeFirstName==null){
                             this.$alert("请完善显示的模型全部内容，才可进行发布", "提示", {
                                confirmButtonText: "确定",
                                });
                                return;
                        }else if(this.multipleSelection[item].urlList==null){
                             this.$alert("请完善显示的模型全部内容，才可进行发布", "提示", {
                                confirmButtonText: "确定",
                                });
                                return;
                        }else if(this.multipleSelection[item].modelDes==null){
                             this.$alert("请完善显示的模型全部内容，才可进行发布", "提示", {
                                confirmButtonText: "确定",
                                });
                                return;
                        }else if(this.multipleSelection[item].remark==null){
                             this.$alert("请完善显示的模型全部内容，才可进行发布", "提示", {
                                confirmButtonText: "确定",
                                });
                                return;
                        }
                    }
                } else {
                    ids.push(val)
                }

                this.$confirm('确定要发布吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    releaseModelList(ids).then((res) => {
                        if(res.success){
                            this.$message({
                                type: 'success',
                                message: '发布成功！'
                            })
                            this.getModelList();
                        }
                    });
                }).catch(() => {})
            },
            handleBatchDownload(val) {
                let data = [];
                let name = "";
                if(val === 'all'){
                    name = "模型";
                    this.multipleSelection.map((item)=>{
                        item.urlList.map( file =>{
                            if(file.fileType ==="FILE"){
                                let obj = {};
                                obj.name = file.name;
                                obj.url = file.url;
                                data.push(obj);
                            }
                        })

                    })
                } else {
                    name = this.tableListData.filter(res => res.uuid === val)[0].modelName;
                    this.tableListData.filter(res => res.uuid === val)[0].urlList.map( file =>{
                        if(file.fileType ==="FILE"){
                            let obj = {};
                            obj.name = file.name;
                            obj.url = file.url;
                            data.push(obj);
                        }
                    })
                }
                downLoad(data, name+new Date().toLocaleString().replace(/年|月|日|上午|下午|:| |\//g, "")+".zip");
            },

        }
    }
</script>

<style scoped lang="less">
.listCommonClass{
    position: relative;
    padding:20px;
    .listSearchBox {
        display: flex;
        flex-wrap: wrap;

        /deep/ .el-input {
            width: initial;
            margin-bottom: 22px;
            margin-right: 30px;
        }

        /deep/ .el-input__inner {
            width: 242px;
            height: 35px;
            min-height: 35px;
            font-size: 12px;
            color: #999999;
            background-color: #f2f4f7;
            border: 1px solid #f2f4f7;
            border-radius: 5px;

            &:hover, &:focus {
                background-color: #fff;
                border: 1px solid #108EE9;
            }
        }

        /deep/ .el-input__prefix {
            top: -3px;
        }

        /deep/ .el-input__suffix {
            top: 2px;
        }

        /deep/ .el-button {
            display: block;
            line-height: 35px;
            padding: 0;
            height: 35px;
        }

        .searchBtn {
            width: 82px;
            background: #3d7fff;
            border: none;
            border-radius: 15px;
            font-size: 14px;
            color: #FFFFFF;
            margin-bottom:22px;
        }

        .resetBtn {
            color: #333333;
            margin-bottom:22px;
        }
    }
    .listTableBox{
        .tableTool {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;

            .toolLeft {
                font-size: 12px;
                color: rgba(0, 0, 0, 0.847);

                .num {
                    color: #356FDF;
                }

                button {
                    padding: 0;
                    margin-left: 15px;
                    width: 80px;
                    height: 30px;
                    background: rgba(242, 244, 247, 1);
                    box-sizing: border-box;
                    border: 1px solid rgba(21, 126, 251, 1);
                    border-radius: 5px;
                    font-size: 12px;
                    color: #157EFB;
                    line-height: 30px;
                    text-align: center;

                    &:hover {
                        background: #157EFB;
                        box-sizing: border-box;
                        border: 1px solid #157EFB;
                        color: #fff;
                    }
                }
            }

            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;

                    i {
                        padding-right: 5px;
                    }

                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }
        .tableContent{
            min-width: 1535px;
            .orderNomesaage {
                color: #888;
                text-align: center;
                padding: 15px 0;
            }
            .tableHeader {
                display: flex;
                width: 100%;
                height: 35px;
                line-height: 35px;
                background: #f2f4f9;
                border-radius: 5px;
                margin: 0 0 15px;
                li {
                    padding: 0 10px;
                    font-size: 14px;
                    color: #333333;
                }
            }
            .tableBody {
                li {
                    width: 100%;
                    border: 1px solid #f2f2f2;
                    border-radius: 10px;
                    font-size: 14px;
                    color: #333333;
                    margin-bottom: 10px;
                    .itemTop {
                        width: 100%;
                        height: 36px;
                        background: #f2f4f9;
                        line-height: 36px;
                        font-size: 14px;
                        color: #333;
                        padding: 0 10px;
                        display: flex;
                        align-items: center;
                        position: relative;
                        span{
                            padding-left: 20px;
                        }
                    }
                    .itemBottom {
                        display: flex;
                        align-items: center;
                        color: #333;
                        font-size: 13px;
                        padding: 10px 0;
                        .name{
                            padding-left: 44px;
                            // text-overflow: ellipsis;
                            // overflow: hidden;
                            // white-space: nowrap;
                            display: flex;
                            align-items: center;

                            img{
                                width: 132px;
                                height: 90px;
                                vertical-align: middle;
                                flex-shrink: 0;
                            }
                            span{
                                margin-left: 10px;
                            }
                        }
                    }
                }
            }
            .name {
                // flex: 1;
                width: 290px;
                text-align: left;
            }
            .classify{
                width: 180px;
                text-align: center;
            }
            .status {
                width: 150px;
                text-align: center;
            }
            .operation {
                width: 300px;
                text-align: center;
            }
        }
        .pagination {
            margin-top: 20px;
            text-align: right;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/production/modelManagement.vue